'use client'

import * as React from 'react'
import { Provider } from 'react-redux'
import { store } from '../store'
import BugsnagProvider from '@/components/Providers/BugsnagProvider'

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <BugsnagProvider>
      <Provider store={store}>{children}</Provider>
    </BugsnagProvider>
  )
}
